<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			收藏
		</div>
		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;"
						v-for="(item,index) in list">
						<div style="width: 65%;height: 100px;float: left;">
							<div style="width: 90%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
								{{item.title}}
							</div>
							<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
								<span class="el-icon-time"></span>
								<span>发布时间：</span>{{getLocalTime(item.create_time)}}
							</div>
						</div>
						<div style="width: 35%;height: 100px;float: left;position: relative;">
							<div  @click="cka(item.pc_link)"
								style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;text-align: center;color: blue;">
								查看
							</div>
							<div @click="detela(item.id,item.mid)"
								style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;text-align: center;">
								取消收藏
							</div>
						</div>
					</div>

			<!-- 分页 -->
			<div style="height: 40px;text-align: center;margin-top: 55px;">
				<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
					:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				list: [],
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
			}
		},
		methods: {
			async getlist() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personal_collection_index', {
					uid: loginInfo.id
				})
				// console.log(res)
				this.list = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			cka(url){
				window.open('https://www.shipoe360.com/#' + url)
				// console.log('https://www.shipoe360.com/#' + url)
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/pages_personal_collection', {
					uid:loginInfo.id,
					page:val
				})
				this.list = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			async detela(item){
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personal_collection_delete',{
					id:item,
					uid:loginInfo.id
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '取消成功',
						type: 'success'
					});
				}
				this.getlist();
			}
		},
		mounted() {
			this.getlist();
		}
	}
</script>

<style>
</style>
